import React from "react";
import PropTypes from "prop-types";

const PartnerLink = ({ provider, nameSEO }) => {
  return (
    <p className="partnerName">
      Content Provided by:&nbsp;
      {nameSEO != null ? (
        <a className="partnerName__link" href={`/partners/${nameSEO}`}>
          <span>{provider}</span>
        </a>
      ) : (
        <span>{provider}</span>
      )}
    </p>
  );
};

PartnerLink.propTypes = {
  nameSEO: PropTypes.string,
  provider: PropTypes.string
};

PartnerLink.defaultProps = {
  nameSEO: null,
  provider: null
};

export default PartnerLink;
